import { Stack, Typography, useTheme } from "@tm/components"

type FormValueProps = {
    label: string
    value: string
}

export function FormValue({ label, value }: FormValueProps) {
    const { opacity } = useTheme()
    return (
        <Stack sx={{ width: "105px", p: "3px 10px" }}>
            <Typography sx={{ fontSize: "10px", textTransform: "uppercase", opacity: opacity?.secondary }}>{label}</Typography>
            <Typography variant="body1">{value}</Typography>
        </Stack>
    )
}
